import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1c1b4d1e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "commit"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contact information", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Linkedin", -1));

const _hoisted_4 = ["href"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy"
}, null, -1));

const _hoisted_6 = [_hoisted_5];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Email", -1));

const _hoisted_8 = {
  id: "shareUrl4"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy"
}, null, -1));

const _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", null, [_createElementVNode("a", {
    target: "_blank",
    href: $data.text,
    id: "shareUrl3"
  }, _toDisplayString($data.text), 9, _hoisted_4), _createElementVNode("button", {
    ref: "copyText",
    class: "copy-btn iconfont icon-fuzhi",
    "data-clipboard-target": "#shareUrl3",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.copy && $options.copy(...args))
  }, _hoisted_6, 512)]), _hoisted_7, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_8, _toDisplayString($data.text1), 1), _createElementVNode("button", {
    ref: "copyText",
    class: "copy-btn iconfont icon-fuzhi",
    "data-clipboard-target": "#shareUrl4",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.copy && $options.copy(...args))
  }, _hoisted_10, 512)])]);
}